
<div class="watermark" *ngIf="env.DEMO != ''">{{env.DEMO}}</div>
<div class="demo-banner" *ngIf="env.DEMO != ''">
<div class="scroll-text">
    ⚠️ {{env.DEMO}} - This environment is for demonstration purposes only. Data shown is not real and may be reset at any time.
</div>
</div>
<div class="container d-flex flex-column h-100 justify-content-center">
    <div class="row flex-grow-1 justify-content-end">
        <div class="col-sm-12 text-center align-self-end">
            <img class="eposmanagerlogo " src="../assets/images/cloudbite-small.svg" />
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm-12 text-center">
            <h1 class="fw-bolder fs-5x text-gray-700 mb-10">Under Maintenance...</h1>
        </div>
        <div class="col-sm-12 text-center">
            <div class="fw-bold fs-6 text-gray-400 mb-15"> System under maintenance now!<br /> Please try again later. </div>
        </div>
        <div class="col-sm-12 text-center">
            <button mat-flat-button color="primary" type="button" id="loginButton" class="px-4" (click)="toHome()"> Home </button>
        </div>
    </div>
    <div class="row  flex-grow-1 py-2">
        <div class="col-sm-12 text-center  align-self-end footertext">
            <app-footer></app-footer>
        </div>
    </div>
</div>